/**
 * These pure adapters keep paid-media dates, labels, and units outside the
 * generic line renderer.
 */
import type { ChartSeries } from 'src/components/paid-media-dashboard/charts/MultiSeriesLineChart';
import { PAID_MEDIA_CHART_COLORS } from 'src/constants';
import type { PaidMediaInsightsTrend } from 'src/store/leela-api';
import { formatCompactNumber } from 'src/utils/formatCompactNumber';

export interface TrendSeriesLabels {
  readonly clicks: string;
  readonly spend: string;
}

export const buildTrendSeries = (
  points: PaidMediaInsightsTrend['points'],
  currency: string,
  labels: TrendSeriesLabels,
): ChartSeries[] => [
  {
    axis: 'primary',
    color: PAID_MEDIA_CHART_COLORS.spend,
    data: points.map(({ date, spend }) => ({ x: date, y: spend })),
    formatValue: (value) => formatCompactNumber(value, currency),
    key: 'spend',
    label: labels.spend,
  },
  {
    axis: 'secondary',
    color: PAID_MEDIA_CHART_COLORS.clicks,
    data: points.map(({ clicks, date }) => ({ x: date, y: clicks })),
    formatValue: formatCompactNumber,
    key: 'clicks',
    label: labels.clicks,
  },
];
